import { render, staticRenderFns } from "./App.vue?vue&type=template&id=24aff3d3&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&setup=true&"
export * from "./App.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./App.vue?vue&type=style&index=0&id=24aff3d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24aff3d3",
  null
  
)

export default component.exports